<template>
  <v-snackbar
    v-model="global.notification.show"
    :timeout="3500"
    :color="global.notification.color"
    location="bottom center"
    multi-line
  >
    <v-container class="py-0 px-3 ma-0">
      <v-row>
        <v-col cols="1" class="d-flex align-center justify-center">
          <v-icon start v-if="global.notification.icon">
            {{ global.notification.icon }}
          </v-icon>
        </v-col>
        <v-col cols="10">
          <strong>{{ global.notification.title }}</strong
          ><br />
          {{ global.notification.text }}
        </v-col>
        <v-col cols="1" class="d-flex align-center justify-center">
          <span icon @click="global.notification.show = false">
            <v-icon>mdi-close</v-icon>
          </span>
        </v-col>
      </v-row>
    </v-container>
  </v-snackbar>
</template>

<script setup>
  const global = window.useGlobalStore();
</script>
